<template slot="header">
  <div>
    <div class="card" v-show="dashdata">
      <div class="card-body">

        <div v-if="getOverallItem" class="mfbox">
          <div class="mfitem">
            <gebrauchtwagenmultiitem :item="getOverallItem"
                              :pro="gesamtItem"
                              :isPercentage="true"
                              :title="gesamtItem"
                              :shouldFillGap="true"
                              :showPoints="showPoints"
                              :showPointsTooltips="showPointsTooltips"
                              tooltip="Lorem ipsum tooltip" />
          </div>
        </div>

        <div v-if="getOverallItem" class="gebrauchtwagenbar-gray gebrauchtwagenbar-line"></div>

        <div class="mfbox" v-if="barStyle === 'rows'">
          <div class="mfitem"
              v-for="(item, index) in getValidItems"
              :key="index">
            <gebrauchtwagenmultiitem :title="item.text"
                                    :shouldFillGap="true"
                                    :isPercentage="true"
                                    :item="item"
                                    :showPoints="showPoints"
                                    :showPointsTooltips="showPointsTooltips"
                                    tooltip="Lorem ipsum tooltip" />
          </div>
        </div>

        <div v-if="overallData" class="gebrauchtwagenbar-gray gebrauchtwagenbar-line"></div>

        <div v-if="overallData" class="mfheader">
          <div class="mfitem " style="height: 0px; width: 0px;"></div>
          <div class="mfshopsitem mfborder" style="flex: initial; margin: 0.75em;">
            <div style="margin: 0.5em;">
              <div class="largetext bold center">{{$t('Webportal.DashboardBMW.NumberOfShops')}} <span class="smalltext">({{$t('Webportal.DashboardBMW.Total')}} {{ getShops() }})</span></div>
              <shopsoverall :overallValues="overallData" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gebrauchtwagenitem from './GebrauchtwagenItem'
  import shopsoverall from './ShopsOverall'
  import legendcontrol from './LegendControl'
  import gebrauchtwagenmultiitem from './GebrauchtwagenMultiItem'

  export default {
    name: 'GebrauchtwagenCockpit',

    props: {
      dashdata: { type: Object },
      usedItems: { type: Array },
      gesamtItem: { type: Object },
      overallData: { type: Object },
      showPoints: { type: Boolean, default: false },
      showPointsTooltips: { type: Boolean, default: true },
      barStyle: {
        type: String,
        default: 'rows',
        validator: function (value) {
          return ['columns', 'rows'].indexOf(value) !== -1
        }
      },
    },

    components: {
      gebrauchtwagenitem,
      shopsoverall,
      legendcontrol,
      gebrauchtwagenmultiitem
    },

    methods: {
      getShops() {
         if (!this.dashdata || !this.dashdata.Overall || _.size(this.dashdata.Overall) < 1) return '-';
         return this.dashdata.Overall[0].NumberOfShopsTotal;
      },

      getSuccessFactorsGroup: function() {
        if (!this.dashdata || !this.dashdata.KPIGroup || _.size(this.dashdata.KPIGroup) < 1) return '-';
        let item = _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === 'Success factors')
        return !item ? '-' : item.KpiName;
      },
      getWorkingStandardGroup: function() {
        if (!this.dashdata || !this.dashdata.KPIGroup || _.size(this.dashdata.KPIGroup) < 1) return '-';
        let item = _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === 'Working Standard')
        return !item ? '-' : item.KpiName;
      },
    },
    computed: {
      getOverallByWave: function() {
        if (!this.dashdata || !this.dashdata.OverallByWave || this.dashdata.OverallByWave.length < 1) return undefined;
        return this.dashdata.OverallByWave[0];
      },

      getValidItems: function() {
        let validItems = [];

        _.forEach(this.usedItems, function(value) {
          if (!value.SurveyWave || value.SurveyWave.length < 1)  return;
          for (let i = 0; i < value.SurveyWave.length; i++) {
            const element = value.SurveyWave[i];
            if (element.Result) {
              validItems.push(value);
              return;
            }
          }
        });

        return validItems;
      },

      getOverallItem: function() {
        if (!this.dashdata || !this.dashdata.OverallByWave || _.size(this.dashdata.OverallByWave) < 1) return undefined;
          return this.dashdata.OverallByWave[0];
      }
    }
  }

</script>

<style scoped>

.card{
  padding: 0em;
  border: solid #BFBFBF;
  border-width: 0em;
  border-radius: 0rem;
  margin-left: 0em;
}
.card-body {
  padding: 0em;
  margin-left: 0em;
  margin-top: 0.25em;
}

</style>
